import ButtonViewFile from './ButtonViewFile';

export default ButtonViewFile;
